import { useTranslation } from "react-i18next";

import { Form } from "antd";
import { HeaderOverview, IRenderPieChart, RenderPieChart } from "components";
import {
  ErrorDashboard,
  LoadingDashboard,
  NoDataDashboard,
  WrapperBG,
  checkData,
} from "pages/overview";
import { useAppLanguage } from "providers/app-language";
import { useOverview } from "providers/overview";
import { useGetDashboardAppliancesCount } from "service/dashboard/central/appliances";

const COLORS = ["#276347", "#F8931D", "#D2D3D5"];

const MostUsedItems = () => {
  const { t } = useTranslation();
  const { findDate, property } = useOverview();
  const { translationObject } = useAppLanguage();

  const workSpaceTopDate = Form.useWatch("workSpaceTopDate");
  const date = findDate(workSpaceTopDate);

  const { data, isFetching, isError, error } = useGetDashboardAppliancesCount({
    ...date,
    property,
  });

  const findData = checkData(data);

  const getData =
    findData?.map((item) => {
      const { name } = translationObject({ object: item, keys: ["name"] });
      return { name: name, count: item.count };
    }) || [];

  const dataPie: IRenderPieChart = {
    data: getData,
    dataName: "name",
    dataKey: "count",
    color: COLORS,
    text: t("times")
  };

  return (
    <WrapperBG>
      <LoadingDashboard loading={isFetching}>
        <HeaderOverview
          title={t("the-most-used-items")}
          name="workSpaceTopDate"
        />
        {isError ? (
          <ErrorDashboard error={error} height="250px" />
        ) : !findData || findData.length <= 0 ? (
          <NoDataDashboard height="250px" />
        ) : (
          <RenderPieChart {...dataPie} />
        )}
      </LoadingDashboard>
    </WrapperBG>
  );
};

export default MostUsedItems;
